import { FORM_FIELDS } from "../utils";

export const STEP_FIELDS: Record<number, string[]> = {
  0: [
    FORM_FIELDS.IMO,
    FORM_FIELDS.NO_IMO_NUMBER,
    FORM_FIELDS.VESSEL_NAME,
    FORM_FIELDS.CALL_SIGN,
    FORM_FIELDS.PORT_OF_REGISTRATION,
    FORM_FIELDS.YEAR_BUILT,
    FORM_FIELDS.DATE_OF_DELIVERY,
    FORM_FIELDS.FLAG,
  ],
  1: [
    FORM_FIELDS.VESSEL_TYPE_CODE,
    FORM_FIELDS.GROSS_TONNAGE,
    FORM_FIELDS.NET_TONNAGE,
    FORM_FIELDS.DEADWEIGHT_TONNAGE,
    FORM_FIELDS.LENGTH_OVERALL,
    FORM_FIELDS.DRAFT_MAX,
    FORM_FIELDS.BEAM,
    FORM_FIELDS.OTHER_VESSEL_CLASSIFICATION_SOCIETY,
  ],
  2: [
    FORM_FIELDS.VESSEL_CLASSIFICATION_SOCIETY,
    FORM_FIELDS.SHIP_OWNER,
    FORM_FIELDS.SHIP_CHARTERER,
    FORM_FIELDS.SHIPS_MANAGEMENT,
    FORM_FIELDS.SHIPS_REGISTERED_OWNER,
    FORM_FIELDS.PI_CLUB,
    FORM_FIELDS.MLC_CLUB,
    FORM_FIELDS.PI_CLUB_OTHER,
    FORM_FIELDS.MLC_CLUB_OTHER,
  ],
  // this is left empty on purpose because we have dynamic cert based on vessel type
  // so it's is populated in the component itself
  3: [],
  4: [FORM_FIELDS.REGISTRATION_REMARKS, FORM_FIELDS.ADDITIONAL_DOCUMENTS],
  5: [
    FORM_FIELDS.NATURE_OF_SERVICE,
    FORM_FIELDS.BUNKERING_COMPANY,
    FORM_FIELDS.NAVIGATION_LICENSE,
    FORM_FIELDS.NAVIGATION_LICENSE_FROM_DATE,
    FORM_FIELDS.NAVIGATION_LICENSE_TO_DATE,
    FORM_FIELDS.CHARTER_PARTY_AGREEMENT,
    FORM_FIELDS.REGISTERED_OWNER,
    FORM_FIELDS.CHARTER_START_DATE,
    FORM_FIELDS.CHARTER_END_DATE,
    FORM_FIELDS.OIL_SPILL_COMPANY,
    FORM_FIELDS.OIL_COMPANY,
    FORM_FIELDS.OIL_SPILL_COMPANY_FROM_DATE,
    FORM_FIELDS.OIL_SPILL_COMPANY_TO_DATE,
    FORM_FIELDS.SIRE_REPORT,
    FORM_FIELDS.SIRE_REPORT_FROM_DATE,
    FORM_FIELDS.SIRE_REPORT_TO_DATE,
    FORM_FIELDS.HOSE_TEST_CERTIFICATE,
    FORM_FIELDS.COMPANY_NAME_HOSE_TEST_CERTIFICATE,
    FORM_FIELDS.HOSE_TEST_CERTIFICATE_EXPIRY_DATE,
    FORM_FIELDS.SHIP_TO_SHIP_PLAN,
    FORM_FIELDS.SHIP_TO_SHIP_PLAN_FROM_DATE,
    FORM_FIELDS.SHIP_TO_SHIP_PLAN_TO_DATE,
    FORM_FIELDS.EFFECTIVE_START_DATE,
    FORM_FIELDS.EFFECTIVE_END_DATE,
    FORM_FIELDS.REMARKS,
    FORM_FIELDS.BUNKER_BARGE_ADDITIONAL_DOCUMENTS,
  ],
};
